'use client';

import type { PropsWithChildren } from 'react';
import { isServer } from '@frameio/utils/config';
import { useActiveAccountId } from '../ActiveEntitiesContext';
import { IsolatedActiveAccountIdContextProvider } from '../ActiveEntitiesContext/ActiveAccountIdContext';

export const LastViewedAccountId = ({ children }: PropsWithChildren) => {
  const activeAccountId = useActiveAccountId();

  const windowStoredAccountId =
    !activeAccountId && !isServer
      ? (window as any).__LAST_VIEWED_ACCOUNT_ID__
      : null;

  const accountId = activeAccountId || windowStoredAccountId;

  return (
    <IsolatedActiveAccountIdContextProvider accountId={accountId}>
      {children}
    </IsolatedActiveAccountIdContextProvider>
  );
};
